import { init } from './App';

declare global {
  interface Window {
    WH: any;
  }
}

init();
